// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@media(max-width:599.9px){.eventSale .container--card[data-v-3905fef6]{width:100%;margin:auto}.eventSale[data-v-3905fef6]  .footer{margin-top:20px}}@media(min-width:600px){.eventSale[data-v-3905fef6]  .container{width:100%}.eventSale[data-v-3905fef6]  .header{margin-bottom:64px}.eventSale[data-v-3905fef6]  .footer{margin-top:66px}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
